import {
  PARAMETER_ACCTID,
  PARAMETER_CONTACTNUMBER,
  PARAMETER_IMPRINTAREACODE,
  PARAMETER_IMPRINTLOCATION,
  PARAMETER_ITEMSKU,
  PARAMETER_SESSIONID,
  PARAMETER_VENDORID,
  configuratorStep,
  studioItemType,
} from '../main/constants';
import { admintoolHostName, colorType, defaultImageColor } from '../utils/constants';
import { catchErrorInfo, closeExternalWaitingCover, getTokenAsync } from '../main/logics';
import { getDefaultColor, imprintAreasInitAsync, imprintColorInitAsync } from '../imprintarea/logics';
import { getTemplateEditorData, updateTemplateEditorData } from './apis';
import {
  hideWaitingCover,
  initializeItemSpec,
  setCurrentImprintAreaKey,
  setCurrentStep,
  showMessageBox,
  showWaitingCover,
} from '../main/actions';
import { initFontDict, initFontSizeRangeDict } from '../text/actions';
import {
  initializeCategoryDict,
  initializeCommonTemplateDict,
  initializeSpecialTemplateDict,
} from '../template/actions';

import { TemplateType } from '../template/constants';
import { addInitTextElements } from '../text/logics';
import { getColorDesc } from '../elements/utils';
import { getImprintColors } from '../imprintarea/selectors';
import { getParameters } from '../main/selectors';
import { getSelectedTemplate } from '../template/selectors';
import { initCanvas } from '../canvas/actions';

export const initializeTemplateEditorAsync = () => (dispatch, getState) => {
  const state = getState();
  const parameters = getParameters(state);
  const tokenRequest = {
    acctId: parameters[PARAMETER_ACCTID] || '',
    contactNumber: Number.isInteger(Number(parameters[PARAMETER_CONTACTNUMBER]))
      ? Number(parameters[PARAMETER_CONTACTNUMBER])
      : 0,
    sessionId: parameters[PARAMETER_SESSIONID] || '',
  };
  getTokenAsync(
    tokenRequest,
    () => {
      const templateEditorRequest = {
        vendorId: parameters[PARAMETER_VENDORID],
        itemId: parameters[PARAMETER_ITEMSKU],
        ImprintAreaCode: parameters[PARAMETER_IMPRINTAREACODE],
        ImprintLocation: parameters[PARAMETER_IMPRINTLOCATION],
      };
      dispatch(initializeTemplateEditorData(templateEditorRequest));
    },
    () => {
      dispatch(setCurrentStep(configuratorStep.error));
      dispatch(closeExternalWaitingCover());
    }
  );
};

export const checkImprintColorEmpty =
  (currentStudioItemType, currentImprintAreaKey, templateTextData) => (dispatch, getState) => {
    templateTextData.forEach((item) => {
      if (currentStudioItemType === studioItemType.digital) {
        if (!item.color.cmyk && !item.color.colorReference) {
          item.color.cmyk = defaultImageColor.cmyk;
          item.color.colorReference = defaultImageColor.rgb;
        }

        if (!item.outlineColor.cmyk && !item.outlineColor.colorReference) {
          item.outlineColor.cmyk = defaultImageColor.cmyk;
          item.outlineColor.colorReference = defaultImageColor.rgb;
        }
        item.color.colorType = colorType.Digital;
        item.color.colorDescription = getColorDesc(item.color.cmyk);
        item.outlineColor.colorType = colorType.Digital;
        item.outlineColor.colorDescription = getColorDesc(item.outlineColor.cmyk);
      } else if (currentStudioItemType === studioItemType.screenPrintedDigital) {
        if (!item.color.cmyk && !item.color.colorReference) {
          const state = getState();
          const imprintColors = getImprintColors(state, currentImprintAreaKey);
          const defaultColor = getDefaultColor(imprintColors);
          item.color.cmyk = defaultColor.cmyk;
          item.color.colorDescription = defaultColor.colorDescription;
          item.color.colorId = defaultColor.colorId;
          item.color.colorReference = defaultColor.colorReference;
          item.color.colorType = defaultColor.colorType;
        }
      }
    });
  };

export const initializeTemplateEditorData = (templateEditorRequest) => (dispatch, getState) =>
  getTemplateEditorData(templateEditorRequest)
    .then((res) => {
      const responseData = res.data;
      const currentImprintAreaKey = Object.keys(responseData.imprintFormats)[0];
      dispatch(initializeItemSpec(responseData.item));
      dispatch(imprintColorInitAsync(responseData.imprintColor));
      dispatch(
        imprintAreasInitAsync({
          imprintFormats: responseData.imprintFormats,
        })
      );
      dispatch(initCanvas(responseData.canvas));
      dispatch(initializeCategoryDict(responseData.category));
      dispatch(initializeSpecialTemplateDict(responseData.specialTemplate));
      dispatch(initializeCommonTemplateDict(responseData.template));
      dispatch(initFontDict(responseData.font));
      dispatch(initFontSizeRangeDict(responseData.fontSizeRange));
      dispatch(
        checkImprintColorEmpty(
          responseData.item.studioItemType,
          currentImprintAreaKey,
          responseData.text[currentImprintAreaKey]
        )
      );
      dispatch(addInitTextElements(responseData.text));
      dispatch(setCurrentImprintAreaKey(currentImprintAreaKey));

      dispatch(setCurrentStep(configuratorStep.canvas));
      dispatch(closeExternalWaitingCover());
      const state = getState();
      const selectedTemplate = getSelectedTemplate(state);
      if (
        selectedTemplate.templateType !== TemplateType.DEFAULT &&
        responseData.item.studioItemType === studioItemType.digital
      )
        dispatch(
          showMessageBox({
            show: true,
            message: 'The default template has not yet been configured.',
          })
        );
    })
    .catch((error) => {
      dispatch(catchErrorInfo(error));
      dispatch(setCurrentStep(configuratorStep.error));
      dispatch(closeExternalWaitingCover());
    });

export const goBackCompositionItemList = () => {
  window.location.href = `${admintoolHostName[process.env.REACT_APP_BUILD_ENV]}/compositionItemList`;
};

export const saveTemplateEditorData =
  (currentStudioItemType, textData, templateId, compositionItemId, itemId, currentImprintFormat, successCallback) =>
  (dispatch) => {
    const text = JSON.parse(JSON.stringify(textData));
    text.forEach((textItem) => {
      textItem.studioItemType = currentStudioItemType;
    });

    let request = {
      text: text,
      templateId: templateId,
      compositionItemId: compositionItemId,
      itemId: itemId,
      imprintAreaCode: currentImprintFormat.imprintAreaCode,
      imprintAreaLocation: currentImprintFormat.location,
    };
    dispatch(showWaitingCover());
    updateTemplateEditorData(request)
      .then(() => {
        successCallback && successCallback();
        dispatch(hideWaitingCover());
        dispatch(
          showMessageBox({
            show: true,
            message: 'Save successfully!',
            onOk: goBackCompositionItemList,
          })
        );
      })
      .catch((error) => {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
